// Login / Forgotten password toggle
$('.forgotten-pass, .loginfrom-link').on('click', function(e) {
	e.preventDefault();
	const $this = $(this);
	const targetString = $this.attr('href').replace('#', '');
	$(`.${targetString}`).show();
	$this
		.closest('form')
		.parent()
		.hide();
});

// Address new
$('.addresses__actions .btn--new, .form--address-new .btn--cancel').on('click', function(e) {
	e.preventDefault();
	const $this = $(this);
	const targetString = $this.attr('href').replace('#', '');
	$(`.${targetString}`).toggle();
});

// Product price update
$('.product-single__variants').on('change', function() {
	const $this = $(this);
	const $option = $this.find('option:selected');
	const $btnSubmit = $this.closest('form').find('input[type="submit"], button[type="submit"]');
	const thisPrice = $this.find('option:selected').data('price');

	$('.product__price').html(thisPrice);

	if ($option.is(':disabled')) {
		$btnSubmit.html(Shopify.theme.locale.products.product.sold_out).prop('disabled', true);
	} else {
		$btnSubmit.html(Shopify.theme.locale.products.product.add_to_cart).prop('disabled', false);
	}
});

// Submit to cart
let selector = '';

$('[data-index]').on('click', function() {
	const $this = $(this);

	$this.prop('checked', true)
	$this.parent().siblings().children('input').prop('checked', false)

	if ( $this.is('input') && $this.prop('checked', true) ){
		const value = $this.val();
		const dataIndex = $this.data('index');

		selector = `[data-option${dataIndex}='${value}']`

		if (!$(selector).prop('disabled')) {
			$(selector).prop('selected', true)
			$('[name="id"]').trigger('change')
		}
	}
})

// Address province option
$('select[name="address[country]"]').each(function() {
	const $this = $(this);
	const thisID = $this.attr('id');
	const province = $this.closest('form').find('select[name="address[province]"]');
	const provinceID = province.attr('id');
	const provinceHolderID = province.closest('.form__row').attr('id');
	new Shopify.CountryProvinceSelector(thisID, provinceID, {
		hideElement: provinceHolderID
	});
});

